import React from "react";

/**
 * Route-level access gate for the Evaluation Tools admin pages.
 *
 * Admits only the content team or above: CONTENT_MANAGER, OKO_STAFF, or
 * SUPERUSER. This mirrors the server-side gate (is_token_or_content_team_auth /
 * can_manage_content) and the sidebar nav gate, both keyed on the same
 * can_manage_content flag from /admin/me. Educators and students never reach it.
 *
 * adminUserData is injected by SidebarView via cloneElement.
 */
export const EvaluationToolsGuard = ({ adminUserData, children }) => {
  const canAccess = adminUserData?.can_manage_content || false;

  if (!canAccess) {
    return (
      <div style={{ padding: "48px", textAlign: "center", color: "#666" }}>
        <h3>Access denied</h3>
        <p>The Evaluation Tools are available to the content team only.</p>
      </div>
    );
  }

  return <>{children}</>;
};
